import React, { useCallback, useEffect, useState } from "react";
import { Card, Space, message } from "antd";
import moment from "moment";

import {
  getDetalleIndicadorProveedores,
  getDetalleIndicadorProveedoresTodos,
  getIndicadoresComplementos,
  getIndicadoresComplementosTodos,
  getXlsDetalleIndicadorProveedores,
} from "./complementosApi";
// import { buildAlertasFromProveedores } from "./complementosUtils";
import FiltrosComplementos from "./features/FiltrosComplementos";
import IndicadoresComplementos from "./features/IndicadoresComplementos";
// import TablaAlertasComplementos from "./features/TablaAlertasComplementos";
import TablaProveedoresComplementos from "./features/TablaProveedoresComplementos";

const indicadoresIniciales = {
  facturasPagadas: 0,
  conComplementoPago: 0,
  pendientes: 0,
};

const cardStyle = {
  overflow: "hidden",
  borderRadius: 14,
  border: "1px solid #f0f0f0",
  boxShadow: "0 10px 24px rgba(17, 48, 97, 0.08)",
};

export default function Complementos() {
  const [fecha, setFecha] = useState(moment());
  const [loading, setLoading] = useState(false);
  const [loadingXls, setLoadingXls] = useState(false);
  const [indicadores, setIndicadores] = useState(indicadoresIniciales);
  const [proveedores, setProveedores] = useState([]);

  const cargarComplementos = useCallback(async () => {
    if (!fecha) return;

    setLoading(true);

    try {
      const payload = { fecha: fecha.format("YYYY") };
      const [indicadoresResult, proveedoresResult] = await Promise.all([
        getIndicadoresComplementos(payload),
        getDetalleIndicadorProveedores(payload),
      ]);

      if (indicadoresResult.code === 0) {
        setIndicadores(indicadoresResult.data || indicadoresIniciales);
      } else {
        message.error("Error al cargar indicadores de complementos");
      }

      if (proveedoresResult.code === 0) {
        setProveedores((proveedoresResult.data || []).map((item, index) => ({
          ...item,
          id: `${item.proveedor}-${index}`,
        })));
      } else {
        message.error("Error al cargar detalle de proveedores");
      }
    } catch (error) {
      message.error("Error al cargar complementos");
    } finally {
      setLoading(false);
    }
  }, [fecha]);

  const cargarTodosComplementos = useCallback(async () => {
    setLoading(true);

    try {
      const [indicadoresResult, proveedoresResult] = await Promise.all([
        getIndicadoresComplementosTodos(),
        getDetalleIndicadorProveedoresTodos(),
      ]);

      if (indicadoresResult.code === 0) {
        setIndicadores(indicadoresResult.data || indicadoresIniciales);
      } else {
        message.error("Error al cargar indicadores de complementos");
      }

      if (proveedoresResult.code === 0) {
        setProveedores((proveedoresResult.data || []).map((item, index) => ({
          ...item,
          id: `${item.proveedor}-${index}`,
        })));
      } else {
        message.error("Error al cargar detalle de proveedores");
      }
    } catch (error) {
      message.error("Error al cargar complementos");
    } finally {
      setLoading(false);
    }
  }, []);

  const descargarXls = async () => {
    if (!fecha) return;

    setLoadingXls(true);

    try {
      const payload = { fecha: fecha.format("YYYY") };
      const detalleResult = await getXlsDetalleIndicadorProveedores(payload);

      if (detalleResult.code !== 0) {
        message.error("Error al descargar XLS de complementos");
      }
    } catch (error) {
      message.error("Error al descargar XLS de complementos");
    } finally {
      setLoadingXls(false);
    }
  };

  useEffect(() => {
    cargarComplementos();
  }, [cargarComplementos]);

  // const alertas = buildAlertasFromProveedores(proveedores);
  // const items = [
  //   {
  //     key: "proveedores",
  //     label: "Proveedores",
  //     children: <TablaProveedoresComplementos dataSource={proveedores} loading={loading} />,
  //   },
  //   {
  //     key: "alertas",
  //     label: "Alertas",
  //     children: <TablaAlertasComplementos dataSource={alertas} loading={loading} />,
  //   },
  // ];

  return (
    <Space direction="vertical" size={12} style={{ width: "100%" }}>
      <div
        className="card__titulo"
        style={{
          color: "var(--color-naranja)",
          fontSize: 18,
          fontWeight: 600,
          lineHeight: 1.2,
          letterSpacing: "0.04em",
          marginBottom: -4,
        }}
      >
        COMPLEMENTOS DE PAGO
      </div>

      <FiltrosComplementos
        fecha={fecha}
        loading={loading}
        onFechaChange={setFecha}
        onActualizar={cargarComplementos}
        onVerTodos={cargarTodosComplementos}
        onDescargarXls={descargarXls}
        loadingXls={loadingXls}
      />

      <IndicadoresComplementos
        indicadores={indicadores}
        proveedores={proveedores}
        loading={loading}
      />

      <Card style={cardStyle}>
        {/* <Tabs defaultActiveKey="proveedores" items={items} /> */}
        <TablaProveedoresComplementos dataSource={proveedores} loading={loading} />
      </Card>
    </Space>
  );
}
